import { Port } from './port';
export class CurvePort extends Port {
    get Location() {
        return this.curve.value(this.parameter);
    }
    set Location(value) {
        throw new Error('Method should not be called.');
    }
    // constructor
    static mk(curve, parameter) {
        const ret = new CurvePort();
        ret.curve = curve;
        ret.parameter = parameter;
        return ret;
    }
    get Parameter() {
        return this.parameter;
    }
    set Parameter(value) {
        this.parameter = value;
    }
    get Curve() {
        return this.curve;
    }
    set Curve(value) {
        this.curve = value;
    }
}
//# sourceMappingURL=curvePort.js.map